// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#cz2.cz2 .cz2__program-line{margin-bottom:15px}#cz2.cz2 .cz2__program-line__label{display:block;margin-bottom:5px}#cz2.cz2 .cz2__program-line__custom{margin-top:5px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
